import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-typing-indicator',
    templateUrl: './typing-indicator.component.html',
    styleUrls: ['./typing-indicator.component.scss'],
    imports: [MatCardModule],
})
export class TypingIndicatorComponent {
    @Input() aiBuffering: boolean;
}
